export default __webpack_public_path__ + "static/media/Wheel-Pointer.1ccba740.png";